module.exports = __webpack_public_path__ + "static/media/26_tn.c2eb0163.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/26_tn.jpg
// module id = 456
// module chunks = 0